module.exports = __webpack_public_path__ + "static/media/klasa_7.5e9d7466.svg";